import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6977dc0e921dc900146d9d6d/subaylar_construction/src/app/services/components/ServicesInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6977dc0e921dc900146d9d6d/subaylar_construction/src/components/common/Header.tsx");
